import React from 'react'

interface JobStatusBadgeProps {
  status: string
}

const statusClasses = {
  pending: 'badge-gray',
  running: 'badge-info',
  completed: 'badge-success',
  failed: 'badge-danger',
  cancelled: 'badge-warning',
}

export default function JobStatusBadge({ status }: JobStatusBadgeProps) {
  return (
    <span
      className={`${
        statusClasses[status as keyof typeof statusClasses] || 'badge-gray'
      }`}
    >
      {status.charAt(0).toUpperCase() + status.slice(1)}
    </span>
  )
}





